module.exports = __webpack_public_path__ + "img/p1.481681b.png";